import Address from '../models/address.model';

/**
 * Read an address retrieved from the backend.
 * @param {Object} o
 * @param {Boolean} readCoordinates Set to true to also read coordinates.
 * @return {Address}
 */
function readAddress(o, readCoordinates=false) {
  let coords = null;
  if (readCoordinates) {
    coords = {lat: o.latitude, lon: o.longitude};
  }

  return new Address(
    o.postal_address,
    o.postal_code,
    o.postal_area,
    coords,
    'country' in o? o.country : null,
    'place_id' in o? o.place_id : null
  );
}

export {
  readAddress
};



// WEBPACK FOOTER //
// ./src/app/common/serializers/address.serializer.js